export { default } from './DestacatEsdeveniment';
